import { useSelector, InboxBrandState, useDispatch } from 'react-redux';
import { useCallback, useEffect, useMemo } from 'react';
import { getInboxBrand } from '@idk-web/api';
import {
  resetBrand,
  selectInboxBrand,
  updateBrand,
} from '@/redux/inboxBrand.slice';
import { selectInboxLoginStatus } from '@/redux/inboxAuth.slice';

export type Brand = {
  brand: InboxBrandState | null;
  reload(): Promise<void>;
};

/**
 * Returns the current inbox brand.
 */
export function useInboxBrand(): Brand {
  const loginStatus = useSelector(selectInboxLoginStatus);
  const dispatch = useDispatch();
  let brand: InboxBrandState | null = useSelector(selectInboxBrand);

  // Brand always returns an object due to how ReduxJs works, but we want to treat it as null if it's empty
  brand = brand.name ? brand : null;

  const reload = useCallback(async () => {
    try {
      const brand = await getInboxBrand();

      dispatch(updateBrand(brand));
    } catch {
      dispatch(resetBrand());
    }
  }, []);

  useEffect(() => {
    if (loginStatus === 'LOGGED_IN' && brand) {
      return;
    }

    void reload();
  }, []);

  return useMemo(
    () => ({
      brand,
      reload,
    }),
    [brand, reload],
  );
}
